<footer class="sb-footer" [ngClass]="{ 'bg-color-white': !isForm }">
    <div class="sb-footer__container">
        @if (isForm) {
            <div class="sb-footer__logo-container">
                @if (configuration.logoLink && !configuration.hideLogo) {
                    <div>
                        @if (configuration.options.customerWebsiteLink) {
                            <a class="link" target="_blank" [href]="configuration.options.customerWebsiteLink">
                                <img class="logo" [alt]="communityName" [src]="configuration.logoLink" />
                            </a>
                        } @else {
                            <img class="logo" [src]="configuration.logoLink" [alt]="communityName" />
                        }
                    </div>
                }
            </div>
            <!--            todo: check and maybe move to settings-->
            @if (communityName === 'sport1') {
                <div id="text-block">
                    Kundeservice telefon: 63 92 82 90
                    <br />
                    Åpningstider: Hverdager 08:00-16:00
                    <br />
                    Adresse: Hovinmovegen 128, 2067 Jessheim
                </div>
            }
        } @else {
            <div class="sb-footer__logo-container">
                @if (configuration.logo) {
                    @if (communityName === 'sport1') {
                        <a class="link" href="http://www.sport1.no/" [title]="'Go to Sport1 Home page' | translate">
                            <img alt="Sport1" class="logo" [src]="configuration.logo" />
                        </a>
                    } @else {
                        @if (configuration.customerWebsiteLink) {
                            <a
                                class="link"
                                title="{{ 'Go to' | translate }} {{ communityName }} {{ 'home page' | translate }}"
                                [href]="configuration.customerWebsiteLink">
                                <img class="logo" [src]="configuration.logo" [alt]="communityName" />
                            </a>
                        } @else {
                            <a
                                class="link"
                                [title]="'Go to Home page' | translate"
                                href="{{ originPath }}/{{ communityName }}/{{ faqName }}">
                                <img class="logo" [src]="configuration.logo" [alt]="communityName" />
                            </a>
                        }
                    }
                }
            </div>

            @if (configuration.footerContent) {
                <div class="sb-footer__content-block" [innerHTML]="configuration.footerContent | safeHtml"></div>
            }
        }

        <div class="sb-footer__links-block">
            <div class="d-flex justify-content-center">
                @if (configuration.facebookLink) {
                    <a
                        [href]="configuration.facebookLink"
                        target="_blank"
                        class="link"
                        [attr.aria-label]="'Follow us on Facebook' | translate">
                        <img src="/sb-tools/theme/images/Facebook.png" alt="Facebook" />
                    </a>
                }
                @if (configuration.instagramLink) {
                    <a
                        [href]="configuration.instagramLink"
                        target="_blank"
                        class="link"
                        [attr.aria-label]="'Follow us on Instagram' | translate">
                        <img src="/sb-tools/theme/images/Instagram.png" alt="Instagram" />
                    </a>
                }
                @if (configuration.twitterLink) {
                    <a
                        [href]="configuration.twitterLink"
                        target="_blank"
                        class="link"
                        [attr.aria-label]="'Follow us on X' | translate">
                        <img src="/sb-tools/theme/images/x.png" alt="X" />
                    </a>
                }
            </div>
        </div>
    </div>

    <span class="sb-footer__powered-by" translate>powered by Socialboards AS</span>
</footer>
